import { Component } from '@angular/core';
import { FooterComponent } from '../../components/footer/footer.component';
import { HeaderComponent } from '../../components/header/header.component';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { DatasearchService } from '../../_services/datasearch.service';

@Component({
  selector: 'app-our-team',
  standalone: true,
  imports: [FooterComponent, HeaderComponent, NgFor, NgIf, NgClass],
  templateUrl: './our-team.component.html',
  styleUrls: ['./our-team.component.scss']
})
export class OurTeamComponent {
  transparent = false;
  showMore: boolean[] = [];
  bio: any[] = [];
  imageBaseUrl = 'https://www.chemrobotics.com/agropat/uploads/team_members/';
  teams: any[] = [];
  head: any[] = [];
  currentPage: string = 'team';
  currentUrl: string;

  constructor(private datasearch: DatasearchService) {
    this.currentUrl = window.location.href; // Get the current URL

  }

  ngOnInit() {
    this.getData();
    this.getHeading();
  }

  getData() {
    this.datasearch.getTeamMembers().subscribe(res => {
      // Filter only active team members
      this.teams = res.data.filter((member: any) => member.isActive === true);
      
      if (this.teams.length > 0) {
        this.bio = this.teams[0].biography;  // Access the biography of the first team member
      }
    });
  }

  getMediaUrl(filename: string | undefined, folder: string): string {
    if (!filename) return 'https://www.chemrobotics.com/agropat/uploads/gallery/placeholder.png';
    if (filename.startsWith('http')) return filename;

    // Ensure accurate prefix
    let cleanPath = filename;
    if (!filename.startsWith('/uploads/')) {
      cleanPath = `/uploads/${folder}/` + filename.replace(/^\//, '');
    }
    return this.datasearch.ApiUrl + cleanPath;
  }

  toggleShowMore(index: number): void {
    this.showMore[index] = !this.showMore[index];
  }

  isDescriptionLong(biography: string): boolean {
    const textWithoutHTML = biography.replace(/<[^>]+>/g, ''); // Remove HTML tags
    return textWithoutHTML.length > 400;  // Check if biography length exceeds 400 characters
  }

  getHeading() {
    this.datasearch.getAllHeadings().subscribe(res => {
      if (res.success) {
        this.head = res.data.filter((heading: any) => heading.page === this.currentPage);
      }
    });
  }
  openLink(url: string) {
    if (url) {
      window.open(url, '_blank');
    }
  }

  getMemberWebLink(member: any): string {
    if (!member) return '';
    // Standard property names
    const possibleKeys = ['web_link', 'member_link', 'link', 'weblink', 'website', 'url', 'web_url', 'web_link_url'];
    for (const key of possibleKeys) {
      if (member[key] && member[key] !== 'null' && member[key] !== 'undefined') return String(member[key]).trim();
    }
    // Fallback: Smart search for anything link-related (avoiding images/logos)
    for (const key in member) {
      const k = key.toLowerCase();
      if ((k.includes('link') || k.includes('url') || k.includes('website'))
        && !k.includes('image') && !k.includes('logo') && !k.includes('poster') && !k.includes('thumb')) {
        const val = member[key];
        if (val && val !== 'null' && val !== 'undefined') return String(val).trim();
      }
    }
    return '';
  }
  shareViaEmail() {
    const subject = 'Check out this page!';
    const body = `Here is the link: ${this.currentUrl}`;
    const mailtoLink = `mailto:?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;

    window.location.href = mailtoLink; // Open the email client
  }

  shareViaSMS() {
    const smsLink = `sms:?body=${encodeURIComponent(this.currentUrl)}`;
    window.location.href = smsLink; // Open SMS app
  }

  shareViaWhatsApp() {
    const text = `Check this out! ${this.currentUrl}`;
    const whatsappLink = `https://wa.me/?text=${encodeURIComponent(text)}`;

    window.open(whatsappLink, '_blank'); // Open WhatsApp share dialog
  }

  shareViaMessenger() {
    const messengerLink = `https://www.messenger.com/share/?link=${encodeURIComponent(this.currentUrl)}`;
    window.open(messengerLink, '_blank'); // Open Messenger share dialog
  }

  shareViaViber() {
    const viberLink = `viber://forward?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(viberLink, '_blank'); // Open Viber share dialog
  }

  shareViaFacebook() {
    const facebookLink = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(this.currentUrl)}`;

    window.open(facebookLink, '_blank'); // Open Facebook share dialog
  }

  shareViaTwitter() {
    const text = `Check this out! ${this.currentUrl}`;
    const twitterLink = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}`;

    window.open(twitterLink, '_blank'); // Open Twitter share dialog
  }

  shareViaLinkedIn() {
    const linkedInLink = `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(linkedInLink, '_blank'); // Open LinkedIn share dialog
  }

  shareViaPinterest() {
    const pinterestLink = `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(pinterestLink, '_blank'); // Open Pinterest share dialog
  }

  shareViaReddit() {
    const redditLink = `https://www.reddit.com/submit?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(redditLink, '_blank'); // Open Reddit share dialog
  }

  shareViaTumblr() {
    const tumblrLink = `https://www.tumblr.com/share/link?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(tumblrLink, '_blank'); // Open Tumblr share dialog
  }

  shareViaTelegram() {
    const telegramLink = `https://t.me/share/url?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(telegramLink, '_blank'); // Open Telegram share dialog
  }

  shareViaVK() {
    const vkLink = `https://vk.com/share.php?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(vkLink, '_blank'); // Open VK share dialog
  }

  shareViaMix() {
    const mixLink = `https://mix.com/add?url=${encodeURIComponent(this.currentUrl)}`;
    window.open(mixLink, '_blank'); // Open Mix share dialog
  }

  shareViaXing() {
    const xingLink = `https://www.xing.com/app/user?op=share;url=${encodeURIComponent(this.currentUrl)}`;
    window.open(xingLink, '_blank'); // Open Xing share dialog
  }

  shareViaLine() {
    const lineLink = `https://line.me/R/share?text=${encodeURIComponent(this.currentUrl)}`;
    window.open(lineLink, '_blank'); // Open Line share dialog
  }

  copyLink() {
    navigator.clipboard.writeText(this.currentUrl).then(() => {
      alert('Link copied to clipboard!');
    });
  }
}
